import { PureComponent } from "react";

import Spinner from "~/components/shared/Spinner";

export default class Loader extends PureComponent {
  static displayName = "Autocomplete.Loader";

  render() {
    return (
      <li className="py-4 text-center">
        <Spinner />
      </li>
    );
  }
}
